export default __webpack_public_path__ + "static/media/amazonas3.54cd0054.jpg";